import CIcon from '@coreui/icons-react';
import _ from 'lodash';
import { runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Component } from 'react';
import { v4 as generateRandomId } from 'uuid';

import { OrmStoreType } from '../../core/Stores/DirectoryStore';
import { OrmUserStoreType } from '../../core/Stores/OrmUserStore';
import NatList from '../../shared/Components/NatList';
import NatListContainer from '../../shared/Components/NatListContainer';
import { listDateTimeFormatter } from '../../shared/Formatters/ListDateTimeFormatter';
import { stringFormatter } from '../../shared/Formatters/StringFormatter';
import NatDefaultCheckbox from '../../shared/Inputs/NatDefaultCheckBox';
import NatFormGroupLabel from '../../shared/Inputs/NatFormGroupLabel';
import NatValueInput from '../../shared/Inputs/NatValueInput';
import { catalog } from '../../shared/support/Catalog';
import { FormContainerPropsType } from '../../shared/support/modelTypes';
import { NaturalPersonsListStoreType } from './NaturalPersonsListStore';

interface PropsType extends FormContainerPropsType<NaturalPersonsListStoreType> {}

interface StateType {}

interface InjectedProps extends PropsType {
	directoryStore: OrmStoreType;
	userStore: OrmUserStoreType;
}

@inject('directoryStore', 'userStore')
@observer
class NaturalPersonsListContainer extends Component<PropsType, StateType> {
	constructor(props: PropsType) {
		super(props);
		this.resetSearchFields = this.resetSearchFields.bind(this);
		this.createFilter = this.createFilter.bind(this);
	}
	get injected() {
		return this.props as InjectedProps;
	}
	createFilter() {
		// if (!_.isEmpty(organizationBankAccountsSearchFields.name)) {
		// 	or = [
		// 		{
		// 			name: {
		// 				like: organizationBankAccountsSearchFields.name,
		// 				options: 'i'
		// 			}
		// 		},
		// 		{
		// 			sequenceNumber: {
		// 				like: organizationBankAccountsSearchFields.name
		// 			}
		// 		}
		// 	];
		// 	filter.where.or = or;
		// }
	}
	resetSearchFields() {
		runInAction(() => {
			this.props.store.chipsFields = {
				name: {
					id: null,
					chips: [],
					title: 'Наименование',
					isLocalizedString: true
				},
				itn: {
					id: null,
					chips: [],
					title: 'ИНН'
				},
				createdAtGt: {
					isDate: true,
					id: null,
					chips: [],
					isGt: true
				},
				createdAtLt: {
					isDate: true,
					id: null,
					chips: [],
					isGt: false
				},
				birthdateGt: {
					isDate: true,
					id: null,
					chips: [],
					isGt: true
				},
				birthdateLt: {
					isDate: true,
					id: null,
					chips: [],
					isGt: false
				},
				gender: {
					isRelation: true,
					id: null,
					chips: [],
					list: []
				},
				deleted: {
					id: false,
					display: { isChecked: false, title: 'Отображать' },
					doNotDisplay: { isChecked: true, title: 'Не отображать' },
					chips: [
						{
							id: generateRandomId(),
							name: {
								ru: 'Удаленные: не отображать'
							}
						}
					],
					isBoolean: true,
					title: 'Удаленные'
				}
			};
		});
	}
	render() {
		return (
			<NatListContainer
				store={this.props.store}
				createFilter={this.createFilter}
				resetSearchFields={this.resetSearchFields}
				defaultFilterWhere={{ deleted: false }}
				navigationRoute={this.props.navigationRoute}
				index={this.props.index}
				ownerId="gender"
				enumerationItems="gender">
				{(childrenProps) => (
					<NatList
						name="naturalPersons"
						store={this.props.store}
						navigationRoute={this.props.navigationRoute}
						goTo={this.props.goTo}
						childrenProps={childrenProps}
						columns={[
							{
								id: 'checkbox',
								pinned: true,
								className: '',
								width: '54px',
								minResizeWidth: 0,
								maxResizeWidth: null,
								resizable: false,
								visible: true,
								headerCellRenderer: () => {
									return <div></div>;
								},
								cellRenderer: ({ onChange, value }: { onChange: any; value: any }) => {
									return (
										<div className="rgt-cell-inner ml-0 mr-0">
											<input type="checkbox" id="checkbox" onChange={onChange} checked={value} />
										</div>
									);
								}
							},
							{
								id: 1,
								field: 'deleted',
								label: '',
								width: '70px',
								cellRenderer: ({ data }: { data: any }) => {
									return <div className="rgt-cell-inner">{<CIcon src={catalog.pickupCatalogStateImage(data)} size="lg" />}</div>;
								},
								sort: () => {}
							},
							{
								id: 2,
								field: 'createdAt',
								label: 'Дата создания',
								cellRenderer: ({ data }: { data: any }) => {
									return (
										<div
											className={(() => {
												if (data.deleted) {
													return 'rgt-cell-inner rgt-text-truncate text-secondary';
												} else {
													return 'rgt-cell-inner rgt-text-truncate';
												}
											})()}>
											{listDateTimeFormatter.renderValue(data.createdAt)}
										</div>
									);
								},
								sort: () => {}
							},
							// {
							// 	id: 3,
							// 	field: 'birthdate',
							// 	label: 'День рождения',
							// 	cellRenderer: ({ data }: { data: any }) => {
							// 		return (
							// 			<div
							// 				className={(() => {
							// 					if (data.deleted) {
							// 						return 'rgt-cell-inner rgt-text-truncate text-secondary';
							// 					} else {
							// 						return 'rgt-cell-inner rgt-text-truncate';
							// 					}
							// 				})()}>
							// 				{listDateTimeFormatter.renderValue(data.birthdate)}
							// 			</div>
							// 		);
							// 	},
							// 	sort: () => {}
							// },
							{
								id: 4,
								field: 'name',
								label: 'Наименование',
								cellRenderer: ({ data }: { data: any }) => {
									return (
										<div
											className={(() => {
												if (data.deleted) {
													return 'rgt-cell-inner rgt-text-truncate text-secondary';
												} else {
													return 'rgt-cell-inner rgt-text-truncate';
												}
											})()}>
											{catalog.renderCatalogName(data)}
										</div>
									);
								},
								sort: () => {}
							}
						]}>
						<>
							{/* <NatFormGroupLabel label="День рождения от" labelColumnSettings="7" labelColumnClassName="text-left align-self-center text-black" row={false}>
								<NatValueInput<Date> object={this.props.store.chipsFields.birthdateGt} property="id" placeholder="Введите дату" type="date" formatter={dateFormatter} size="sm" />
							</NatFormGroupLabel>
							<NatFormGroupLabel label="до" labelColumnSettings="3" labelColumnClassName="text-left align-self-center text-black" row={false}>
								<NatValueInput<Date> object={this.props.store.chipsFields.birthdateLt} property="id" placeholder="Введите дату" type="date" formatter={dateFormatter} size="sm" />
							</NatFormGroupLabel> */}
							<NatValueInput<string> object={this.props.store.chipsFields.itn} property="id" placeholder="Введите ИНН" type="text" formatter={stringFormatter()} size="sm" autoComplete="off" label="ИНН" />
							<NatFormGroupLabel label="Пол" labelColumnSettings="12" labelColumnClassName="text-left align-self-center" inputColumnClassName="pl__4_5" row={false}>
								{_.map(this.props.store.chipsFields.gender.list, (item, index) => {
									return <NatDefaultCheckbox key={index} object={item} property="isChecked" columnClassName="" wrapperClassName="checkbox" row={true} label={catalog.renderCatalogName(item)} />;
								})}
							</NatFormGroupLabel>
						</>
					</NatList>
				)}
			</NatListContainer>
		);
	}
}

export default NaturalPersonsListContainer;
